import React from "react";

const Banner = ({ image, heading, subheading }) => {
  return (
    <section
      className="position-relative text-center text-white"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "400px",
      }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
      ></div>
      <div className="position-relative d-flex flex-column justify-content-center align-items-center h-100">
        <h1
          className="fw-bold fs-1 text-white d-inline-block p-3 rounded"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          {heading}
        </h1>

        {subheading && <p className="lead">{subheading}</p>}
      </div>
    </section>
  );
};

export default Banner;
